module.exports = __webpack_public_path__ + "media/img/decorations/history-year-after-desk-81d0534e7549bf7611a70a80aa62bdd6.svg";